import { Link } from "react-router-dom";
import { useLanguage } from "@/i18n/LanguageContext";

export default function HeaderStrip() {
  const { t } = useLanguage();
  return (
    <div className="bg-primary py-5">
      <div className="max-w-7xl mx-auto px-4 md:px-6 flex flex-col sm:flex-row items-center justify-between gap-2">
        <nav className="text-sm text-white/90">
          <Link to="/" className="hover:text-white transition-colors">
            {t("serviceAreas.breadcrumbHome")}
          </Link>
          <span className="mx-2 text-white/60">&gt;</span>
          <span className="text-white font-medium">{t("serviceAreas.breadcrumbName")}</span>
        </nav>
        <p className="text-sm text-white font-medium">
          {t("serviceAreas.headerRightText")}
        </p>
      </div>
    </div>
  );
}